// src/components/LegalPanel.js
// Componente reutilizable para pintar bloques de texto legal (términos,
// privacidad, etc.) a partir de datos, en vez de tener el JSX repetido y
// hardcodeado en cada sitio donde se necesite mostrar texto legal.
import React from 'react';

export default function LegalPanel({ title, sections }) {
  return (
    <div className="mx-4 my-2 rounded-2xl p-5" style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}}>
      <p style={{color: 'white', fontSize: '13px', fontWeight: '700', marginBottom: '16px'}}>{title}</p>
      {sections.map((s, i) => (
        <div key={s.titulo}>
          <p style={{color: '#f97316', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px'}}>
            {s.titulo}
          </p>
          <p style={{color: '#9ca3af', fontSize: '12px', lineHeight: '1.7', marginBottom: i === sections.length - 1 ? '0' : '14px'}}>
            {s.texto}
          </p>
        </div>
      ))}
    </div>
  );
}